/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Explorer_Display_New_Folder_Success_ToastInputs */



/**
* | output |
* | --- |
* | "Folder \"{name}\" created successfully" |
*
* @param {Explorer_Display_New_Folder_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_new_folder_success_toast = /** @type {((inputs: Explorer_Display_New_Folder_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_New_Folder_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Dossier "${i?.name}" cree avec succes`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Ordner "${i?.name}" erfolgreich erstellt`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Cartella "${i?.name}" creata correttamente`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Папка "${i?.name}" успешно создана.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Carpeta "${i?.name}" creada correctamente`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`文件夹“${i?.name}”已成功创建。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`フォルダ「${i?.name}」が正常に作成されました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`फ़ोल्डर "${i?.name}" सफलतापूर्वक बनाया गया`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Pasta "${i?.name}" criada com sucesso`)
	return /** @type {LocalizedString} */ (`Folder "${i?.name}" created successfully`)
});